import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Loader2 } from "lucide-react";

const GeofenceNotificationDetail: React.FC = () => {
    const notificationDetail = useSelector((state: RootState) => state.notification.notificationDetail);
    const isLoading = useSelector((state: RootState) => state.notification.isNotificationDetailLoading);
    const geoDetails = notificationDetail?.geo_violation_details;
    const requestor = geoDetails?.requestor;
    const eventDetails = geoDetails?.event_details;
    const tracking = geoDetails?.tracking_details;

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-40 w-full">
                <Loader2 className="w-8 h-8 text-gray-600 animate-spin" />
            </div>
        );
    }

    return (
        <div className="p-4 max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-4">Geofence Violation</h2>
            <div className="bg-white rounded-xl shadow p-4">
                <div className="font-bold text-lg mb-2">{requestor?.name || "-"}</div>
                <hr className="mb-2" />
                <div className="mb-2">
                    <span className="text-gray-500">Clock-In Time</span>
                    <div className="text-xl">{tracking?.last_punch_time ? new Date(tracking.last_punch_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "-"}</div>
                </div>
                <div className="mb-2">
                    <span className="text-gray-500">Clock-Out Time</span>
                    <div className="text-xl">{eventDetails?.event_time ? new Date(eventDetails.event_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "-"}</div>
                </div>
                <div className="mb-2">
                    <span className="text-gray-500">Violation Time</span>
                    <div className="text-xl">{eventDetails?.event_time ? new Date(eventDetails.event_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "-"}</div>
                </div>
                <div className="mb-2">
                    <span className="text-gray-500">Event</span>
                    <div className="text-xl">{eventDetails?.event_text || eventDetails?.event_type || "-"}</div>
                </div>
                <div className="mb-10 rounded overflow-hidden">
                    {tracking?.lat && tracking?.lng && (
                        <button
                            type="button"
                            className="w-full p-0 border-0 bg-transparent cursor-pointer"
                            onClick={() => {
                                const lat = tracking.lat;
                                const lng = tracking.lng;
                                const isAndroid = /Android/i.test(navigator.userAgent);
                                const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

                                let url = `https://maps.google.com/?q=${lat},${lng}`;
                                if (isAndroid) {
                                    url = `geo:${lat},${lng}?q=${lat},${lng}`;
                                } else if (isIOS) {
                                    url = `maps://maps.apple.com/?q=${lat},${lng}`;
                                }
                                window.open(url, "_blank");
                            }}
                        >
                            <iframe
                                title="Geofence Location"
                                width="100%"
                                height="250"
                                frameBorder="0"
                                style={{ border: 0 }}
                                src={`https://maps.google.com/maps?q=${tracking.lat},${tracking.lng}&z=15&output=embed`}
                                allowFullScreen
                            />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GeofenceNotificationDetail;
